import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const AppliedChemistry = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Fuels: Classification and Characteristics of fuels, Calorific values, Comparison between solid, liquid and gaseous
        fuels, calorimeter, Calorific value of fuel, Theoretical calculation of calorific value of a fuel, Types of fuels:
        Solid (coal), Liquid (Petroleum products, refining, cracking, synthetic petrol, Knocking and rating), Gaseous
        (Natural, CNG, LPG, Coal gas, Oil gas, Producer Gas, Water gas), Non-Conventional sources of energy.
        Water treatment: Introduction, Hardness of water, Disadvantages of hard water, Water usage in Industries,
        boiler problems with hard water, Water-softening, Drinking Water, Desalination, Defluoridation, Waster Water
        Management, Chemical Analysis of Water, and corrosion (effect, type, mechanism, control).</p>
    </div>,
    <div key="2" className="p-4">
      <p>Phase rule: Phase diagram, Water System, Sulphur System, Two Component System (Pb-Ag, Zn-Mg, Fe-C),
        Metalals, Alloys, Heat treatment of steel.
        Polymers: Classification, functionality, Mechanism of Polymerization, Molecular weight of Polymers, Plastics,
        Rubbers, Fibres, Specialty Polymers, Degradation of Polymers, Polymer Composites, Adhesives.
        Lubricants: Functions, Mechanism of lubrication, classification, synthetic and natural lubricants, lubricating
        emulsions, properties, selection on the basis of usage.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Water: Introduction, water quality standards, physical, chemical and biological characteristics; hardness of water, disadvantages of hardness, determination of hardness (EDTA method) and related numerical questions. Alkalinity and its determination; Boiler problems with hard water and their prevention: Scale and sludge formation, boiler corrosion, caustic embrittlement, priming and foaming, boiler water treatment - internal or in-situ: carbonate and phosphate conditioning, colloidal and Calgon conditioning; external treatment: (a) Lime soda process and related numericals (b) Zeolite process and numericals, (c) Ion-exchange process. Municipal water supply - its treatment and disinfection using break -point chlorination. Desalination, Reverse Osmosis, Electrodialysis and defluoridation of water.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Corrosion and its Control: Definition, effects, theory (mechanisms): dry/chemical, wet/electrochemical corrosion, Pilling-Bedworth ratio; Types of corrosion: Galvanic corrosion, Soil corrosion, Pitting corrosion, Concentration cell or Differential Aeration corrosion, Stress corrosion; Mechanism of rusting of iron, Passivity. Factors influencing corrosion; protective measures: galvanization, tinning, cathodic protection, sacrificial anodic protection; electroplating and prevention of corrosion through material selection and design. Green Technology and Green Chemistry Twelve Principles of Green Chemistry, Zero Waste Technology, Atom economy, Use of alternative feedstock, innocuous reagents, alternative solvents, designing alternative reaction methodology, minimising energy consumption. Nano Chemistry: Nanomaterials: Properties, synthesis and surface characterization techniques BET and TEM and applications.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'youtube_playlist',
      label: 'Video Lectures',
      content: null, // Will be replaced in SubjectPage
    },
  ];

  return (
    <SubjectPage
      subjectName="Applied Chemistry"
      subjectKey="appliedChemistry"
      branch="CSE"
      semester="2nd Semester"
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'AppliedChemistryNotes',
        videos: 'AppliedChemistryVideos'
      }}
    />
  );
};

export default AppliedChemistry;